<template>
	<div class="rma">
		<page title="Reklamation">
			<div class="box" v-if="!successMsg">
				<div class="fields">

					<template v-for="(field, i) in fields">
						<div class="line" v-if="field.line" :key="i"/>
						<rmaField v-else :key="field.name" v-bind="field" v-model="data[field.name]"/>
					</template>
				</div>

				<div class="send">
					<btn v-bind="{loading, disabled: uploadError}" @click="send">Indsend</btn>
				</div>

				<div class="uploadError" v-if="uploadError">
					max størrelse på billeder er 25mb
				</div>
			</div>

			<div class="msg" v-else v-text="successMsg"/>
		</page>
	</div>
</template>

<script>
import toFormData from "object-to-formdata";

import rmaField from "./field.vue";
import btn from "@/components/button.vue";
import page from "@/components/order/page.vue";
import vInput from "@/components/order/fields/input.vue";
import vSelect from "@/components/order/fields/select.vue";
import vTextarea from "@/components/order/fields/textarea.vue";

export default {
	components: {page, btn, rmaField, vInput, vSelect, vTextarea},
	data() {
		return {
			maxUploadSize: 25000000,
			successMsg: false,
			loading: false,

			data: {
				"Forhandler": "",
				"Medarbejder": "",
				"Ordrenummer": "",
				"Linjenummer": "",
				"Kort beskrivelse": "",
				"Billeder": []
			}
		}
	},
	computed: {
		uploadError: (t) => t.data.Billeder.reduce((size, file) => size + file.size, 0) >= t.maxUploadSize,
		reseller: (t) => t.$store.getters["user/reseller"],
		user: (t) => t.$store.getters["user/data"],

		fields: () => [
			{
				name: "Forhandler",
				props: {
					type: "input",
					disabled: true
				}
			},
			{
				name: "Medarbejder",
				props: {
					type: "input",
					disabled: true
				}
			},
			{
				name: "Ordrenummer",
				required: true,
				tooltip: {
					text: `Ordrenummeret er 6 cifre ved Stila og 7 ved PAC`
				},
				props: {
					type: "input"
				}
			},
			{
				name: "Linjenummer",
				tooltip: {
					text: `Indtast tallene på de ordrerlinjer reklamationen drejer sig om, separeret af et komma`
				},
				required: true,
				props: {
					type: "input"
				}
			},
			{
				line: true
			},
			{
				name: "Kort beskrivelse",
				props: {
					type: "textarea"
				}
			},
			{
				name: "Billeder",
				description: "NB! Ved upload af flere filer på iOS, vælg fotobibliotek",
				props: {
					type: "upload",
					max: 5,
					extensions: [".png", ".jpg", ".jpeg"]
				}
			},
			{
				line: true
			}
		],

		formData: (t) => toFormData({
			fields: [
				{label: "Forhandler", value: t.data["Forhandler"]},
				{label: "Medarbejder", value: t.data["Medarbejder"]},
				{label: "Ordrenummer", value: t.data["Ordrenummer"]},
				{label: "Linjenummer", value: t.data["Linjenummer"]},
				{label: "Kort beskrivelse", value: t.data["Kort beskrivelse"]}
			],
			attachments: t.data["Billeder"].length ? t.data["Billeder"] : undefined
		}, {indices: true})
	},
	methods: {
		async send() {
			const error = document.querySelector("*[data-error=true]");
			if (this.loading) return;

			if (!error) {
				this.loading = true;
				const {data: {message}} = await this.$axios.post("client/orders/return", this.formData);
				this.successMsg = message;
				this.loading = false;
			} else {
				error.scrollIntoView();
				window.scrollBy(0, -300);
			}
		}
	},
	created() {
		if (this.reseller) {
			this.data = {...this.data, ...{
				"Forhandler": `${this.reseller.name} (${this.reseller.account_number})`,
				"Medarbejder": this.user.name
			}};
		}
	}
};
</script>

<style lang="scss" scoped>
.rma {

	.box {
		background-color: $white1;
		border: 1px solid #979797;
		padding: 56px 78px;

		@include res(tablet) {
			padding: 28px 39px;
		}

		.fields {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;

			.line {
				height: 1px;
				width: 100%;
				margin: 22px 0 40px;
				background-color: #F5F5F5;
			}
		}

		.send {
			text-align: right;

			.button {
				text-transform: uppercase;
				padding: 1.25em;

				@include res(tablet) {
					width: 100%;
				}
			}
		}

		.uploadError {
			color: $red1;
			margin-top: 1em;
			font-size: 12px;
			text-align: right;
		}
	}

	.msg {
		color: $green1;
		font-size: 18px;
	}
}
</style>
